<template>
  <v-container>
    <NewEditCategory
      v-model="ShowNewEditCategory"
      :isEdit="isEditCategory"
      :selectedCategory="selectedCategory"
      :preferences="placePreferences"
      :types="types"
      @createCategory="createCategory"
      @editCategory="editCategory"
    />
    <v-row justify="start" class="pt-0">
      <v-col cols="12" class="d-flex justify-space-between align-center">
        <v-text-field
          :hint="$t('general.search')"
          clearable
          class="mr-3"
          color="kbDarkBlue"
          :placeholder="$t('general.search')"
        ></v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <v-btn dark @click="showCreateCategory" color="kbPurple">
                Create Place Category
              </v-btn>
            </div>
          </template>
          <span>
            Create Place Category
          </span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="placeCategories"
          class="elevation-2"
          :loading="loadingCategories"
          :footer-props="{
            'items-per-page-text': $t('general.assistantsPerPage'),
            'items-per-page-options': [50, 100, 200],
          }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="text-center">
                <v-switch class="center-switch"
                          color="kbDarkBlue"
                          @change="toggleActiveCategory(item)"
                          v-model="item.active"
                          hide-details>
                </v-switch>
              </td>
              <td class="font-weight-bold text-capitalize">
                {{ item.name }}
              </td>
              <td>{{ item.type }}</td>
              <td>
                <div class="data-table-actions d-flex justify-end align-center">
                  <v-menu>
                    <template v-slot:activator="{ on }">
                      <v-btn color="kbDarkBlue" text icon v-on="on">
                        <v-icon>more_vert</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item @click="showEditCategory(item)">
                        <v-list-item-action>
                          <v-icon color="kbDarkBlue">edit</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Edit Category</v-list-item-title>
                      </v-list-item>

                      <!-- <v-list-item @click="deleteCategory(item)">
                        <v-list-item-action>
                          <v-icon color="kbDarkBlue">delete</v-icon>
                        </v-list-item-action>
                        <v-list-item-title>Delete Category</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:no-data>
            <v-row>
              <v-col class="text-center" cols="12" v-if="loadingCategories">
                Loading Categories
              </v-col>
              <v-col cols="12" class="red--text text-center" v-else>
                Categories not registered
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import NewEditCategory from './dialogs/NewEditCategory'
export default {
  created () {
    this.getPlacePreferences()
    this.$store.dispatch('getPlaceCategories')
  },
  data: () => ({
    types: ['restaurant', 'bar', 'experience', 'club', 'speakeasy', 'adventure',
      'landmark', 'hotel', 'museum', 'cultural_center', 'park', 'gym',
      'shopping_mall', 'parking_lot', 'theater', 'coffee_shop', 'library', 'house',
      'other'],
    selectedCategory: {},
    loadingCategories: false,
    ShowNewEditCategory: false,
    isEditCategory: false
  }),
  components: { NewEditCategory },
  computed: {
    ...mapState({
      placePreferences: (state) => state.events.placePreferences,
      placeCategories: (state) => state.events.placeCategories
    }),
    headers () {
      return [
        { text: this.$t('general.status'), align: 'left', value: 'active', sortable: true },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Actions', value: 'actions', align: 'right' }
      ]
    }
  },
  methods: {
    getPlacePreferences () {
      this.$store.commit('SET_PAGINATION_PLACE_PREFERENCES', {
        page: 1,
        itemsPerPage: 100
      })
      this.$store.dispatch('getPlacePreferences')
      this.$store.commit('SET_PAGINATION_PLACE_PREFERENCES', {})
    },
    showCreateCategory () {
      this.ShowNewEditCategory = true
    },
    createCategory (category) {
      this.$store
        .dispatch('createPlaceCategories', category)
        .then(() => {
          this.$store.dispatch('getPlaceCategories')
          notifications.success('Category Created')
        })
        .catch((error) => {
          notifications.error(error)
        })
    },
    showEditCategory (category) {
      const categorySelected = {
        ...category,
        preferences: category.preferences.map((preference) => preference._id)
      }
      this.selectedCategory = categorySelected
      this.ShowNewEditCategory = true
      this.isEditCategory = true
    },
    editCategory (category, categoryId) {
      const data = { category, categoryId }
      this.$store
        .dispatch('updatePlaceCategory', data)
        .then(() => {
          this.$store.dispatch('getPlaceCategories')
          notifications.success('Category Updated')
        })
        .catch((error) => {
          console.error(error)
        })
    },
    deleteCategory (category) {
      console.log('delete category')
    },
    async toggleActiveCategory (category) {
      const toggledActiveCategory = {
        active: category.active
      }
      await this.editCategory(toggledActiveCategory, category.id)
    }
  },
  watch: {
    ShowNewEditCategory (value) {
      if (value === false) {
        this.isEditCategory = false
        this.selectedCategory = {}
      }
    }
  }
}
</script>
